import MarkdownIt from 'markdown-it';
import xss, { whiteList } from 'xss';

import hljs from 'modules/hljs';
import { logger } from 'services/logger';

export default function mdToHtml(text: string, options?: { safe?: boolean; highlight?: boolean }) {
    const { safe = true } = options || {};

    const md = new MarkdownIt({
        linkify: true,
        html: !safe,
        xhtmlOut: !safe,
        breaks: true,
        typographer: true,
        highlight: function (str, lang) {
            if (lang && hljs.getLanguage(lang)) {
                try {
                    return hljs.highlight(lang, str).value;
                } catch (error) {
                    logger.error(error);
                }
            }

            try {
                return hljs.highlightAuto(str).value;
            } catch (error) {
                logger.error(error);
            }

            return '';
        }
    });

    return xss(md.render(text), { whiteList: { ...whiteList, span: ['class'] } })
        .replace(/<code.*?>/g, '<code class="hljs">')
        .replace(/<a href/g, '<a rel="nofollow noopener noreferrer" target="_blank" href');
}
